// Material UI
import { AlertTitle, Box, styled } from '@mui/material';
import { Alert as _Alert } from '@mui/material';

// Components
import { AlertButton } from 'components/ui/alerts';

// Utility
import { useHistory } from 'react-router-dom';

export default function ConnectAlert(props) {
    const {
        connect_type_id,
        charges_enabled,
        payouts_enabled,
        onboarding_complete,
        requirements_due,
    } = props;

    const history = useHistory();

    // Host did not complete their Connect Onboarding

    if (connect_type_id && !onboarding_complete) {
        if (connect_type_id === 3) {
            return (
                <Alert
                    action={
                        <Box
                            display={'flex'}
                            flex={1}
                            flexDirection={'column'}
                            justifyContent={'center'}
                        >
                            <AlertButton
                                severity="warning"
                                onClick={() => history.push(`/settings`)}
                            >
                                Connect
                            </AlertButton>
                        </Box>
                    }
                >
                    <AlertTitle>You are almost ready to sell tickets.</AlertTitle>
                    Connect your Stripe account so your payments go straight to you.
                </Alert>
            );
        } else {
            return (
                <Alert
                    action={
                        <AlertButton severity="warning" onClick={() => history.push(`/settings`)}>
                            Connect
                        </AlertButton>
                    }
                >
                    Please complete your FrontDoor+ Payments onboarding before publishing an event.
                </Alert>
            );
        }
    }

    // There is a problem with the host's Connected Account

    if (connect_type_id && (requirements_due || !charges_enabled || !payouts_enabled)) {
        return (
            <Alert
                action={
                    <AlertButton severity="warning" onClick={() => history.push(`/settings`)}>
                        View Account
                    </AlertButton>
                }
            >
                Action is required on your{' '}
                {connect_type_id === 3
                    ? 'Stripe account'
                    : 'FrontDoor+ Payments account (powered by Stripe)'}
                . Your ability to sell tickets, and collect payments will be impacted soon.
            </Alert>
        );
    }

    // No issues found
    // Either host has a completed connect account, or they are on legacy payments

    return null;
}

const Alert = styled(_Alert)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    '& .MuiAlert-action': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
    },
}));
Alert.defaultProps = { severity: 'warning', variant: 'filled' };
